import type { Adventure } from '../../types'

// Age 5: First Additions
export const additionStarterAdventure: Adventure = {
  id: 'addition-starter',
  title: 'First Additions',
  theme: 'addition',
  targetAge: '5',
  difficulty: 'easy',
  estimatedDuration: 7,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Welcome back, math whiz! Today we're going to ADD numbers together! Adding is like putting things together!",
      duration: 6
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look! I have 2 apples. And here comes 1 more apple. If we put them together, how many apples do we have?",
      duration: 6,
      background: 'math-forest'
    },
    choice1: [
      {
        id: 'solve-it',
        label: 'Solve it!',
        tillyLine: "Let's add them up! 2 apples plus 1 apple equals...?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '2 + 1 = ?',
      tillyPrompt: 'What is 2 plus 1?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      num1: 2,
      num2: 1
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Excellent! 2 plus 1 equals 3! Now let's try another one. I see 1 star, and 2 more stars join it!",
      duration: 6,
      background: 'night-sky'
    },
    choice2: [
      {
        id: 'add-stars',
        label: 'Add the stars!',
        tillyLine: "How many stars are there altogether?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '1 + 2 = ?',
      tillyPrompt: 'What is 1 plus 2?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      num1: 1,
      num2: 2
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're amazing at adding! Now for the FINAL CHALLENGE - 2 plus 2!",
        duration: 5,
        background: 'math-forest'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'simple-addition',
          question: '2 + 2 = ?',
          tillyPrompt: 'What is 2 plus 2?',
          options: [
            { id: '3', label: '3', isCorrect: false },
            { id: '4', label: '4', isCorrect: true },
            { id: '5', label: '5', isCorrect: false }
          ],
          num1: 2,
          num2: 2
        } as any
      ]
    },
    reward: {
      tillyLine: "WOW! You're an ADDITION MASTER! You can add numbers! Here's your special badge!",
      badgeName: 'Addition Master',
      badgeIcon: '➕',
      nextPreview: 'Next time, we\'ll discover patterns!'
    }
  }
}
